import {Component, OnInit} from "@angular/core";
import {WorkflowService} from "./workflow.service";

@Component({
  templateUrl: "./workflow-jump.template.pug",
})
export class WorkflowJumpComponent implements OnInit {
  constructor(public workflowService: WorkflowService) {}

  ngOnInit(): any {
    this.workflowService.reset();
    return undefined;
  }
}
